import {
  InputLabel,
  Select,
  MenuItem,
  TextField,
  FormControl,
  Grid,
} from "@mui/material";
import Price from "../components/Price";
import {
  seepageOptionProvider,
  seepagePriceProvider,
} from "../providers/seepageProvider";

interface IProps {
  state: any;
  setState: (state: any) => void;
}

export default function ItemSepageObject(props: IProps) {
  const types = seepageOptionProvider();

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={5}>
        <FormControl fullWidth>
          <InputLabel>Hloubka</InputLabel>
          <Select
            label="Hloubka"
            value={props.state.type}
            size="small"
            onChange={(e) =>
              props.setState({ ...props.state, type: e.target.value })
            }
          >
            {types.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={2}>
        <FormControl fullWidth>
          <TextField
            label="Počet"
            size="small"
            value={props.state.quantity}
            onChange={(e) =>
              props.setState({ ...props.state, quantity: e.target.value })
            }
            type="number"
            inputProps={{ min: 0 }}
          />
        </FormControl>
      </Grid>
      <Grid item xs={5}>
        <Price data={props.state} provider={seepagePriceProvider} />
      </Grid>
    </Grid>
  );
}
